"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const InfiniteStream_1 = require("./InfiniteStream");
class StreamUtil {
    static fromIterator(it) {
        return InfiniteStream_1.default.of(it.next().value, previous => it.next().value);
    }
}
exports.default = StreamUtil;
